<template>
	<div class="container">
		<div class="page page-settings">
			<!-- Header -->
			<div class="page-header">
				<div class="row">
					<div class="col-md-9">
						<h1 class="page-title">{{ $t('Settings') }}</h1>
					</div>
					<div class="col-md-3">
						<div class="page-header-right text-right"></div>
					</div>
				</div>
			</div>

			<div class="page-content">
				<div class="box p-0" v-if="isUserCan('admin_setting_action_product_sourcing_fee')">
					<!-- Product Sourcing Fee -->
					<div class="integration-item">
						<div class="integration-app">
							<div class="wrapper">
								<div class="integration-app-logo">
									<div class="d-flex align-items-center">
										<div class="text mr-2">{{ $t('Product Sourcing Fee') }}</div>
										<i
											class="material-icons cursor-default"
											v-tooltip="
												'Product Sourcing Fee 5% from HPP Charged from Seller'
											"
											>info</i
										>
									</div>
								</div>
							</div>
						</div>
						<div>
							<div class="integration-accounts">
								<div class="integration-account">
									<div class="wrapper">
										<div class="integration-account__name">
											<slot> Enabled : <b>{{ productSourcingFee.enabled ? 'Yes' : 'No' }}</b> </slot>
										</div>
										<div class="integration-account__actions">
											<smart-toggle
												v-tooltip="'Product Sourcing Fee Toggle'"
												v-model="productSourcingFee.enabled"
												@input="onChangeProductSourcingFee"
											/>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
				<div class="box p-0">
					<!-- Meta Pixel -->
					<div class="integration-item">
						<div class="integration-app">
							<div class="wrapper">
								<div class="integration-app-logo">
									<div class="d-flex align-items-center">
										<div class="text mr-2">{{ $t('Meta Pixel') }}</div>
										<i
											class="material-icons cursor-default"
											v-tooltip="'Manage Meta Pixel'"
										>
											info
										</i>
									</div>
								</div>
							</div>
						</div>
						<div>
							<div class="integration-accounts">
								<div class="loading-wrapper-pixel" v-if="isFetching">
									<div class="is-loading large dark m-auto"></div>
								</div>
								<div class="integration-account" v-else>
									<div class="wrapper mb-2 d-flex flex-wrap" v-for="(pixelItem, idx) in allowedMetaPixels" :key="idx">
										<div class="integration-account__name mb-2">
											<div class="text-bold">{{ pixelItem.label }}</div>
											<table>
												<tr>
													<td>Pixel ID</td>
													<td class="px-2">:</td>
													<td>{{ formatPixelIds(pixelItem) }}</td>
												</tr>
												<tr>
													<td>Tracking Event</td>
													<td class="px-2">:</td>
													<td>{{ formatTrackingEvents(pixelItem) }}</td>
												</tr>
											</table>
										</div>
										<div class="integration-account__actions d-flex align-items-center">
											<smart-toggle
												v-tooltip="'Pixel Item Toggle'"
												v-model="pixelItem.enabled"
												@input="onChangeEnabledPixelItem"
											/>
											<button
												type="button"
												class="integration-account__edit btn-plain"
												v-tooltip="'Edit'"
												@click="openModalMetaPixel(pixelItem)"
											>
												<i class="material-icons">edit</i>
											</button>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
				<div class="box p-0">
					<!-- Google Analytics -->
					<div class="integration-item">
						<div class="integration-app">
							<div class="wrapper">
								<div class="integration-app-logo">
									<div class="d-flex align-items-center">
										<div class="text mr-2">{{ $t('Google Analytics') }}</div>
										<i
											class="material-icons cursor-default"
											v-tooltip="
												'Manage Google Analytics Key'
											"
											>info</i
										>
									</div>
								</div>
							</div>
						</div>
						<div>
							<div class="integration-accounts">
								<div class="integration-account">
									<div class="wrapper">
										<div class="integration-account__name">
											<slot> Key : {{ googleAnalyticsKey }} </slot>
										</div>
										<div class="integration-account__actions">
											<button
												type="button"
												class="integration-account__edit btn-plain"
												v-tooltip="'Edit'"
												@click="openModalGoogleAnalytics"
											>
												<i class="material-icons">edit</i>
											</button>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
				<div class="box p-0">
					<!-- WatZap API Key -->
					<div class="integration-item">
						<div class="integration-app">
							<div class="wrapper">
								<div class="integration-app-logo">
									<div class="d-flex align-items-center">
										<div class="text mr-2">{{ $t('WatZap') }}</div>
										<i
											class="material-icons cursor-default"
											v-tooltip="
												'Manage WatZap API Key'
											"
											>info</i
										>
									</div>
								</div>
							</div>
						</div>
						<div>
							<div class="integration-accounts">
								<div class="integration-account">
									<div class="wrapper mb-3">
										<div class="integration-account__name">
											<table>
												<tr>
													<td>Base URL</td>
													<td class="px-2">:</td>
													<td>{{ whatsapp.base_url }}</td>
												</tr>
												<tr>
													<td>API Key</td>
													<td class="px-2">:</td>
													<td>{{ whatsapp.api_key }}</td>
												</tr>
											</table>
										</div>
										<div class="integration-account__actions">
											<button
												type="button"
												class="integration-account__edit btn-plain"
												v-tooltip="'Edit'"
												@click="openModalWatzap"
											>
												<i class="material-icons">edit</i>
											</button>
										</div>
									</div>
									<div class="wrapper">
										<table class="table table-responsive-sm table-responsive-md">
											<thead>
												<tr>
													<th>Phone Number</th>
													<th>Number Key</th>
												</tr>
											</thead>
											<tbody>
												<tr v-for="(value,index) in whatsapp.devices" :key="index">
													<td>
														<div class="row">
															<div class="col-sm-3 col-lg-1">
																<i class="bi bi-whatsapp text-success icon-whatsapp"></i>
															</div>
															<div class="col-sm-9 col-lg-11">
																<div class="phone">
																	{{ value.phone_number }}
																</div>
																<div class="label">
																	{{ value.label }}
																</div>
															</div>
														</div>
													</td>
													<td class="align-middle">{{ value.number_key }}</td>
												</tr>
											</tbody>
										</table>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>

				<div class="box p-0">
					<!-- Notif Receiver -->
					<div class="integration-item">
						<div class="integration-app">
							<div class="wrapper">
								<div class="integration-app-logo">
									<div class="d-flex align-items-center">
										<div class="text mr-2">{{ $t('Notif Receiver') }}</div>
										<i
											class="material-icons cursor-default"
											v-tooltip="'Mengatur penerima notifikasi WhatsApp'"
										>
											info
										</i>
									</div>
								</div>
							</div>
						</div>
						<div class="integration-accounts">
							<div class="integration-account">
								<div class="wrapper mb-3">
									<button class="btn btn-primary" @click="toggleNotifReceiverModal(true, 'create')">
										<i class="material-icons">add</i>
										<span>Add Receiver</span>
									</button>
								</div>
								<div class="wrapper">
									<div class="table-responsive">
										<table class="table table-responsive-sm table-responsive-md mb-0">
											<thead>
												<tr>
													<th>Phone Number</th>
													<th>Capabilities</th>
													<th>Action</th>
												</tr>
											</thead>
											<tbody>
												<tr v-for="(item, index) in notifReceiver" :key="index">
													<td>
														<div class="d-flex">
															<i class="bi bi-whatsapp text-success icon-whatsapp"></i>
															<div class="ml-4">
																<div class="phone">
																	{{ item.phone_number }}
																</div>
																<div class="label">
																	{{ item.label }}
																</div>
															</div>
														</div>
													</td>
													<td>
														<div v-for="(it, idx) in notifReceiverCapabilities" :key="idx">
															<label class="no-wrap">
																<input
																	type="checkbox"
																	class="input-checkbox input-checkbox-large"
																	:value="it.key"
																	v-model="item.capabilities"
																>
																<span></span>
																<span class="input-checkbox-text d-inline-flex align-items-center">
																	<span class="mr-1">{{ it.label }}</span>
																	<i class="material-icons cursor-default" v-tooltip="{ boundariesElement: 'body', content: it.info }">info</i>
																</span>
															</label>
														</div>
													</td>
													<td>
														<div class="d-flex no-wrap">
															<i class="material-icons cursor-pointer mr-2" @click="toggleNotifReceiverModal(true, 'edit', item)">edit</i>
															<i class="material-icons cursor-pointer text-danger" @click="removeReceiver(index)">delete</i>
														</div>
													</td>
												</tr>
											</tbody>
										</table>

										<div class="list-empty table-empty mb-3" v-if="notifReceiver.length === 0 && !isFetching">
											<i class="material-icons mr-2 va-m">error_outline</i>
											<span class="va-m">{{ $t('No data was found') }}</span>
										</div>

										<div class="table-fetch-status" v-if="isFetching">
											<div class="is-loading large dark m-auto"></div>
										</div>
									</div>
								</div>
								<div class="wrapper mb-3 d-flex justify-content-end" v-if="notifReceiver.length > 0 || isOnDeleteNotifReceiver">
									<button
										type="button"
										class="btn btn-primary"
										:class="{ 'is-loading': isSaveChange }"
										@click="saveNotifReceiver"
									>
										<i class="material-icons">save</i>
										<span>Save</span>
									</button>
								</div>
							</div>
						</div>
					</div>
				</div>

				<div class="box p-0">
					<!-- Best Seller View -->
					<div class="integration-item">
						<div class="integration-app">
							<div class="wrapper">
								<div class="integration-app-logo">
									<div class="d-flex align-items-center">
										<div class="text mr-2">{{ $t('Best Seller View - Whitelist') }}</div>
										<i
											class="material-icons cursor-default"
											v-tooltip="'Mengatur seller agar bisa melihat katalog Best Seller tanpa harus mempunyai order terlebih dahulu.'"
										>
											info
										</i>
									</div>
								</div>
							</div>
						</div>
						<div class="integration-accounts">
							<div class="integration-account">
								<div class="wrapper mb-3">
									<button class="btn btn-primary" @click="toggleBestSellerViewModal(true, 'create')">
										<i class="material-icons">add</i>
										<span>Add Seller</span>
									</button>
								</div>
								<div class="wrapper">
									<div class="table-responsive">
										<table class="table table-responsive-sm table-responsive-md mb-0">
											<thead>
												<tr>
													<th>Seller</th>
													<th>Email</th>
													<th>Updated At</th>
													<th>Action</th>
												</tr>
											</thead>
											<tbody>
												<tr v-for="(item, index) in bestSellerViews" :key="index">
													<td>
														<div class="seller">
															<div class="name">
																<b>{{ item.seller_name }}</b>
															</div>
															<div class="id">
																{{ item.seller_id }}
															</div>
														</div>
													</td>
													<td>{{ item.seller_email }}</td>
													<td>{{ item.updated_at }}</td>
													<td>
														<div class="d-flex no-wrap">
															<!-- <i class="material-icons cursor-pointer mr-2" @click="toggleBestSellerViewModal(true, 'edit', item)">edit</i> -->
															<i class="material-icons cursor-pointer text-danger" v-tooltip="'Hapus Seller'" @click="removeBestSellerView(index)">delete</i>
														</div>
													</td>
												</tr>
											</tbody>
										</table>
										<div class="list-empty table-empty mb-3" v-if="bestSellerViews.length === 0 && !isFetching">
											<i class="material-icons mr-2 va-m">error_outline</i>
											<span class="va-m">{{ $t('No data was found') }}</span>
										</div>
										<div class="table-fetch-status" v-if="isFetching">
											<div class="is-loading large dark m-auto"></div>
										</div>
									</div>
								</div>
								<div class="wrapper mb-3 d-flex justify-content-end" v-if="bestSellerViews.length > 0 || isOnDeleteBestSellerView">
									<button
										type="button"
										class="btn btn-primary"
										:class="{ 'is-loading': isSaveChange }"
										@click="saveBestSellerView"
									>
										<i class="material-icons">save</i>
										<span>Save</span>
									</button>
								</div>
							</div>
						</div>
					</div>
				</div>

				<div class="box p-0">
					<!-- Product Approval Time -->
					<div class="integration-item">
						<div class="integration-app">
							<div class="wrapper">
								<div class="integration-app-logo">
									<div class="d-flex align-items-center">
										<div class="text mr-2">{{ $t('Product Approval Time') }}</div>
										<i
											class="material-icons cursor-default"
											v-tooltip="
												'Approval time adalah waktu tunggu untuk menyetujui produk ketika terjadi perubahan harga'
											"
											>info</i
										>
									</div>
								</div>
								<!-- <button type="button" class="integration-app-button btn btn-primary" @click="isShowModalProductApprovalTime = true">+ Add Email Account</button> -->
							</div>
						</div>
						<div>
							<div class="integration-accounts">
								<div class="integration-account">
									<div class="wrapper">
										<div class="integration-account__name">
											<slot> H+{{ productApprovalTime }} </slot>
										</div>
										<div class="integration-account__actions">
											<button
												type="button"
												class="integration-account__edit btn-plain"
												v-tooltip="'Edit'"
												@click="isShowModalProductApprovalTime = true"
											>
												<i class="material-icons">edit</i>
											</button>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
				<div class="box p-0">
					<!-- Welcoming Message -->
					<div class="integration-item">
						<div class="integration-app">
							<div class="wrapper">
								<div class="integration-app-logo">
									<div class="d-flex align-items-center">
										<div class="text mr-2">{{ $t('Welcoming Message') }}</div>
										<i
											class="material-icons cursor-default"
											v-tooltip="
												'Template welcoming message whatsapp untuk user baru Supplier & Seller'
											"
											>info</i
										>
									</div>
								</div>
							</div>
						</div>
						<div>
							<div class="integration-accounts">
								<div class="integration-account">
									<div class="wrapper">
										<div class="container-fluid p-0">
											<div class="row">
												<div class="col-12">
													<ul class="nav nav-tabs nav-fill">
														<li v-for="(category, index) in welcomingMessageCategories" :key="index" class="nav-item">
															<a class="nav-link" :class="{ 'active' : selectedWelcomingMessageCategory.key === category.key }" @click="setSelectedWelcomingMessageCategory(category)">{{ category.label }}</a>
														</li>
													</ul>
													<div class="tab-content" id="nav-tab-fuContent">
														<div class="fu-editor box">
															<div class="tab-pane">
																<textarea
																	rows="8"
																	class="form-control fu-editor__textarea"
																	v-model="welcomingMessages[selectedWelcomingMessageCategory.key]"
																	ref="content">
																</textarea>
															</div>
														</div>
													</div>
												</div>
												<div class="col-12 mt-4 form-group text-right">
													<button
														type="button"
														class="btn btn-primary d-flex align-items-center ml-a"
														:class="[{ 'is-loading': isSaveChange }]"
														@click="setWelcomingMessage">
														<i class="material-icons">save</i>
														<span>{{ $t('Save') }}</span>
													</button>
												</div>
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
				<div class="box p-0">
					<!-- Follow Up Text -->
					<div class="integration-item">
						<div class="integration-app">
							<div class="wrapper">
								<div class="integration-app-logo">
									<div class="d-flex align-items-center">
										<div class="text mr-2">{{ $t('Follow-up Text') }}</div>
										<i
											class="material-icons cursor-default"
											v-tooltip="
												'Template follow up whatsapp untuk follow up User & Supplier'
											"
											>info</i
										>
									</div>
								</div>
								<!-- <button type="button" class="integration-app-button btn btn-primary" @click="isShowModalProductApprovalTime = true">+ Add Email Account</button> -->
							</div>
						</div>
						<div>
							<div class="integration-accounts">
								<div class="integration-account">
									<div class="wrapper">
										<div class="container-fluid p-0">
											<div class="row">
												<div class="col-12">
													<div class="text-bold mb-2">Follow-up User</div>
													<ul class="nav nav-tabs nav-fill">
														<li v-for="(category, index) in categories" :key="index" class="nav-item">
															<a class="nav-link" :class="{ 'active' : selectedCategoryUser.key === category.key }" @click="setSelectedCategory('user', category, index)">{{ category.label }}</a>
														</li>
													</ul>
													<div class="tab-content" id="nav-tab-fuContent">
														<div class="fu-editor box">
															<div class="tab-pane">
																<textarea
																	rows="8"
																	class="form-control fu-editor__textarea"
																	v-model="followUpTextUser[selectedCategoryUser.index].message"
																	ref="content">
																</textarea>
															</div>
														</div>
													</div>
												</div>
												<div class="col-12 mt-4">
													<div class="text-bold mb-2">Follow-up Supplier</div>
													<ul class="nav nav-tabs nav-fill">
														<li v-for="(category, index) in categories" :key="index" class="nav-item">
															<a class="nav-link" :class="{ 'active' : selectedCategorySupplier.key === category.key }" @click="setSelectedCategory('supplier', category, index)">{{ category.label }}</a>
														</li>
													</ul>
													<div class="tab-content" id="nav-tab-fuContent">
														<div class="fu-editor box">
															<div class="tab-pane">
																<textarea
																	rows="8"
																	class="form-control fu-editor__textarea"
																	v-model="followUpTextSupplier[selectedCategorySupplier.index].message"
																	ref="content">
																</textarea>
															</div>
														</div>
													</div>
												</div>
												<div class="col-12 mt-4 form-group text-right">
													<button
														type="button"
														class="btn btn-primary d-flex align-items-center ml-a"
														:class="[{ 'is-loading': isSaveChange }]"
														@click="setFollowUpText">
														<i class="material-icons">save</i>
														<span>{{ $t('Save') }}</span>
													</button>
												</div>
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
		<div class="modals">
			<!-- Product Change Price Approval Time -->
			<modal
				class="integration-modal"
				:size="'medium'"
				v-if="isShowModalProductApprovalTime"
				@close="
					isShowModalProductApprovalTime = false;
					productApprovalTime = currentApprovalTime;
				"
			>
				<div slot="header">
					<h3>Product Change Price Approval Time</h3>
				</div>
				<div slot="body">
					<!-- <h4 class="modal-title">How to Integrate</h4> -->
					<div class="integration-actions">
						<label class="text-left">Number of days</label>
						<input
							v-focus
							@focus="$event.target.select()"
							type="number"
							min="0"
							class="input form-control"
							placeholder="Product Change Price Approval Time in Days"
							@keyup.enter="saveProductApprovalTime"
							v-model="productApprovalTime"
						/>
					</div>
				</div>
				<div slot="footer">
					<button
						class="btn btn-light"
						@click="
							isShowModalProductApprovalTime = false;
							productApprovalTime = currentApprovalTime;
						"
					>
						{{ $t('Close') }}
					</button>
					<button
						type="button"
						class="btn btn-primary"
						:disabled="productApprovalTime.length === 0"
						:class="{ 'is-loading': isSaveChange }"
						@click="saveProductApprovalTime"
					>
						Save
					</button>
				</div>
			</modal>

			<!-- Watzap Modal -->
			<modal
				class="integration-modal"
				:size="'medium'"
				v-if="isShowModalWatZap"
				@close="isShowModalWatZap = false;"
			>
				<div slot="header">
					<h3>Manage WatZap API Key</h3>
				</div>
				<div slot="body">
					<div class="integration-actions">
						<div class="form-group">
							<label class="text-left">Base URL</label>
							<input
								v-focus
								type="text"
								class="input form-control"
								placeholder="Base URL"
								v-model="whatsappForm.base_url"
								@keyup.enter="saveWatzap"
							/>
						</div>
						<div class="form-group">
							<label class="text-left">API Key</label>
							<input
								type="text"
								class="input form-control"
								placeholder="API Key"
								v-model="whatsappForm.api_key"
								@keyup.enter="saveWatzap"
							/>
						</div>
						<div class="devices well mb-3" v-for="(value,index) in whatsappForm.devices" :key="index">
							<h5>Device {{ index+1 }}</h5>
							<div class="form-group">
								<div class="row">
									<div class="col-md-6">
										<div class="form-group">
											<label class="text-left">Phone Number</label>
											<input
												type="text"
												class="input form-control"
												placeholder="Phone Number"
												v-model="value.phone_number"
												@keyup.enter="saveWatzap"
											/>
										</div>
									</div>
									<div class="col-md-6">
										<div class="form-group">
											<label class="text-left">Label</label>
											<input
												type="text"
												class="input form-control"
												placeholder="Label"
												v-model="value.label"
												@keyup.enter="saveWatzap"
											/>
										</div>
									</div>
								</div>
								<div class="form-group">
									<label class="text-left">Number Key</label>
									<input
										type="text"
										class="input form-control"
										placeholder="Number Key"
										v-model="value.number_key"
										@keyup.enter="saveWatzap"
									/>
								</div>
							</div>
						</div>
					</div>
				</div>
				<div slot="footer">
					<button
						class="btn btn-light"
						@click="isShowModalWatZap = false;"
					>
						{{ $t('Close') }}
					</button>
					<button
						type="button"
						class="btn btn-primary"
						:disabled="isDisableWatZapForm"
						:class="{ 'is-loading': isSaveChange }"
						@click="saveWatzap"
					>
						Save
					</button>
				</div>
			</modal>

			<!-- Google Analytics Modal -->
			<modal
				class="integration-modal"
				:size="'medium'"
				v-if="isShowModalGoogleAnalytics"
				@close="isShowModalGoogleAnalytics = false;"
			>
				<div slot="header">
					<h3>Manage Google Analytics Key</h3>
				</div>
				<div slot="body">
					<div class="integration-actions">
						<div class="form-group">
							<label class="text-left">Key</label>
							<input
								v-focus
								type="text"
								class="input form-control"
								placeholder="Base URL"
								v-model="googleAnalyticsKeyForm"
								@keyup.enter="saveGoogleAnalytics"
							/>
						</div>
					</div>
				</div>
				<div slot="footer">
					<button
						class="btn btn-light"
						@click="isShowModalGoogleAnalytics = false;"
					>
						{{ $t('Close') }}
					</button>
					<button
						type="button"
						class="btn btn-primary"
						:disabled="googleAnalyticsKeyForm.length === 0"
						:class="{ 'is-loading': isSaveChange }"
						@click="saveGoogleAnalytics"
					>
						Save
					</button>
				</div>
			</modal>

			<!-- Meta Pixel Modal -->
			<modal
				class="integration-modal"
				:size="'medium'"
				v-if="isShowModalMetaPixel"
				@close="isShowModalMetaPixel = false;"
			>
				<div slot="header">
					<h3>Manage Meta Pixel - {{ selectedMetaPixel.label }}</h3>
				</div>
				<div slot="body">
					<div class="integration-actions">
						<div class="form-group">
							<label class="text-left">Pixel ID</label>
							<div class="selected-options" v-if="selectedPixelIds.length > 0">
								<div class="selected-option" v-for="(pixelId, index) in selectedPixelIds" :key="index">
									<span>{{ pixelId }}</span>
									<i
										class="material-icons selected-option-remove"
										v-tooltip="'Remove'"
										@click="removePixelId(index)"
									>
										close
									</i>
								</div>
							</div>
							<multiselect
								:placeholder="$t('Input or Select Pixel ID')"
								:options="unselectedPixelIds"
								:hide-selected="true"
								:multiple="true"
								:taggable="true"
								:reset-after="true"
								:show-labels="false"
								tag-placeholder="Press enter to insert Pixel ID"
								@tag="addPixelId"
								@select="addPixelId">
							</multiselect>
						</div>

						<div class="form-group">
							<label class="text-left">Tracking Event</label>
							<div class="selected-options" v-if="selectedPixelEvents.length > 0">
								<div class="selected-option flex-center justify-content-between" v-for="(pixelEvent, index) in selectedPixelEvents" :key="index">
									<span>{{ pixelEvent }}</span>
									<i
										class="material-icons selected-option-action selected-option-remove"
										v-tooltip="'Remove'"
										@click="removePixelEvent(index)"
									>
										close
									</i>
								</div>
							</div>
							<multiselect
								:placeholder="$t('Input or Select Pixel Event')"
								:options="unselectedPixelEvents"
								:hide-selected="true"
								:multiple="true"
								:taggable="true"
								:reset-after="true"
								:show-labels="false"
								tag-placeholder="Press enter to insert Pixel Event"
								@tag="addPixelEvent"
								@select="addPixelEvent"
							>
							</multiselect>
						</div>
					</div>
				</div>
				<div slot="footer">
					<button
						class="btn btn-light"
						@click="isShowModalMetaPixel = false;"
					>
						{{ $t('Close') }}
					</button>
					<button
						type="button"
						class="btn btn-primary"
						:class="{ 'is-loading': isSaveChange }"
						@click="saveMetaPixel('form')"
					>
						Save
					</button>
				</div>
			</modal>

			<!-- Notif Receiver Modal -->
			<modal
				class="integration-modal"
				:size="'medium'"
				v-if="isShowModalNotifReceiver"
				@close="toggleNotifReceiverModal(false)"
			>
				<div slot="header">
					<h3>{{ this.notifReceiverState === 'create' ? 'New' : 'Edit' }} Notif Receiver</h3>
				</div>
				<div slot="body">
					<div class="integration-actions">
						<div class="row">
							<div class="col-12">
								<div class="form-group">
									<label class="text-left">Phone Number</label>
									<input
										type="text"
										@input="inputPhone"
										class="input form-control"
										:class="{ 'is-invalid': notifReceiverError.phone_number }"
										placeholder="Phone Number"
										v-model="notifReceiverItem.phone_number"
										@keyup.enter="validateNotifReceiver"
									/>
									<small v-if="notifReceiverError.phone_number" class="invalid-feedback">{{ notifReceiverError.phone_number }}</small>
								</div>
							</div>
							<div class="col-12">
								<div class="form-group">
									<label class="text-left">Label</label>
									<input
										type="text"
										class="input form-control"
										:class="{ 'is-invalid': notifReceiverError.label }"
										placeholder="Label"
										v-model="notifReceiverItem.label"
										@keyup.enter="validateNotifReceiver"
									/>
									<small v-if="notifReceiverError.label" class="invalid-feedback">{{ notifReceiverError.label }}</small>
								</div>
							</div>
							<div class="col-12">
								<div class="form-group">
									<label class="text-left">Capabilities</label>
									<div class="row">
										<div class="col" v-for="(item, idx) in notifReceiverCapabilities" :key="idx">
											<label>
												<input
													type="checkbox"
													class="input-checkbox input-checkbox-large"
													:value="item.key"
													v-model="notifReceiverItem.capabilities"
												>
												<span></span>
												<span class="input-checkbox-text d-inline-flex align-items-center">
													<span class="mr-1">{{item.label}}</span>
													<i class="material-icons cursor-default" v-tooltip="item.info">info</i>
												</span>
											</label>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
				<div slot="footer">
					<button class="btn btn-light" @click="toggleNotifReceiverModal(false)">
						{{ $t('Close') }}
					</button>
					<button
						type="button"
						class="btn btn-primary"
						:class="{ 'is-loading': isSaveChange }"
						@click="validateNotifReceiver"
					>
						{{ this.notifReceiverState === 'create' ? 'Save' : 'Update' }}
					</button>
				</div>
			</modal>

			<!-- Product Sourcing Fee Confirm Modal -->
			<modal v-if="isShowModalConfirmProductSoucingFee" class="modal-notice-export-modal" :size="'medium'" :hide-footer="true" @close="onCancelProductSourcingFee">
				<div slot="header">
					<h3>Product Sourcing Fee</h3>
				</div>
				<div slot="body">
					<div class="alert alert-warning d-flex">
						<span>Apakah anda yakin akan <b>{{ productSourcingFee.enabled ? 'Mengaktifkan' : 'Menonaktifkan' }}</b> pemotongan <b>Product Sourcing Fee sebesar 5% dari HPP</b> untuk Seller?</span>
					</div>
					<div slot="footer" class="d-flex justify-content-end">
						<button class="btn btn-primary" :class="{ 'is-loading': isSaveChange }" @click="saveProductSourcingFee">
							Ya
						</button>
						<button class="btn btn-default ml-2" @click="onCancelProductSourcingFee">
							Batal
						</button>
					</div>
				</div>
			</modal>

			<!-- Best Seller View Modal -->
			<modal
				class="integration-modal"
				:size="'medium'"
				v-if="isShowModalBestSellerView"
				@close="toggleBestSellerViewModal(false)"
			>
				<div slot="header">
					<h3>{{ this.bestSellerViewState === 'create' ? 'Add' : 'Edit' }} Best Seller View - Whitelist</h3>
				</div>
				<div slot="body">
					<div class="integration-actions">
						<div class="row">
							<div class="col-12">
								<div class="form-group">
									<label class="text-left">Select Seller</label>
									<!-- Search Recent Seller -->
									<multiselect
										v-model="bestSellerViewSelectedSeller"
										:show-labels="false"
										class="form-control"
										:class="isFetchingSellers && 'is-loading'"
										track-by="_id"
										label="label"
										:custom-label="sellerOptionLabel"
										:options="sellerOptions"
										placeholder="Input Seller Name Here..."
										@search-change="searchSeller"
										@select="onBestSellerViewSellerSelected"
									>
										<span slot="noResult">
											No options matching the query
										</span>
										<span slot="noOptions">
											No options available
										</span>
									</multiselect>
									<small v-if="bestSellerViewError.seller_id" class="text-danger">{{ bestSellerViewError.seller_id }}</small>
								</div>
							</div>
						</div>
					</div>
				</div>
				<div slot="footer">
					<button class="btn btn-light" @click="toggleBestSellerViewModal(false)">
						{{ $t('Close') }}
					</button>
					<button
						type="button"
						class="btn btn-primary"
						:class="{ 'is-loading': isSaveChange }"
						@click="validateBestSellerViewForm"
					>
						{{ this.bestSellerViewState === 'create' ? 'Save' : 'Update' }}
					</button>
				</div>
			</modal>

		</div>

		<notifications group="settings" position="bottom right" />
	</div>
</template>

<script>
import dayjs from 'dayjs';
import { mapGetters, mapActions } from 'vuex';
import Modal from '@/components/Modal.vue';
import SmartToggle from '@/components/SmartToggle.vue';
import settingApi from '@/api/setting';
import usersApi from '@/api/user';
import { duplicateVar, getAxiosErrorMessage } from '@/lib/helper';
import {
	defaultFollowUpMessage,
	defaultWhatsappAPI,
	defaultWelcomingMessage,
	metaPixelItems,
	notifReceiverCapabilities,
	pixelEvents,
} from '@/lib/statics';

export default {
	name: 'settingsNotification',
	components: {
		Modal,
		SmartToggle,
	},
	data() {
		return {
			isShowModalProductApprovalTime: false,
			isShowModalWatZap: false,
			isShowModalGoogleAnalytics: false,
			isFetching: false,
			isSaveChange: false,
			params: [],
			currentApprovalTime: '',
			productApprovalTime: '',
			categories: [
				{
					key: 'follow-up-1',
					label: 'Follow Up 1',
				},
				{
					key: 'follow-up-2',
					label: 'Follow Up 2',
				},
			],
			welcomingMessageCategories: [
				{
					key: 'supplier',
					label: 'Supplier',
				},
				{
					key: 'dropshipper',
					label: 'Seller',
				},
			],
			selectedWelcomingMessageCategory: {
				key: 'supplier',
				label: 'Supplier',
			},
			selectedCategoryUser: {
				index: 0,
				key: 'follow-up-1',
				label: 'Follow Up 1',
			},
			selectedCategorySupplier: {
				index: 0,
				key: 'follow-up-1',
				label: 'Follow Up 1',
			},
			followUpTextUser: [
				...defaultFollowUpMessage,
			],
			followUpTextSupplier: [
				...defaultFollowUpMessage,
			],
			welcomingMessages: duplicateVar(defaultWelcomingMessage),
			whatsapp: defaultWhatsappAPI,
			whatsappForm: defaultWhatsappAPI,
			googleAnalyticsKey: '',
			googleAnalyticsKeyForm: '',
			notifReceiver: [],
			isShowModalNotifReceiver: false,
			notifReceiverItem: {
				label: '',
				phone_number: '',
				capabilities: [],
			},
			notifReceiverState: 'edit', // create, edit
			notifReceiverCapabilities,
			notifReceiverError: {
				label: '',
				phone_number: '',
			},
			isShowModalConfirmProductSoucingFee: false,
			productSourcingFee: {
				enabled: false,
			},
			pixelEvents,
			metaPixels: [],
			selectedMetaPixel: {
				label: '',
				type: '',
				enabled: false,
				ids: [],
				events: [],
			},
			isShowModalMetaPixel: false,
			metaPixelRegister: {
				label: 'Register',
				type: 'register',
				enabled: false,
				ids: [],
				events: [],
			},
			selectedPixelIds: [],
			selectedPixelEvents: [],
			isFetchingSellers: false,
			sellerOptions: [],
			bestSellerViews: [],
			isShowModalBestSellerView: false,
			bestSellerViewSelectedSeller: null,
			bestSellerViewItem: {
				seller_id: null,
				seller_name: null,
				seller_email: null,
				updated_at: null,
			},
			bestSellerViewState: 'edit', // create, edit
			bestSellerViewError: {
				seller_id: '',
				seller_name: '',
			},
			isOnDeleteBestSellerView: false,
			isOnDeleteNotifReceiver: false,
		};
	},
	methods: {
		...mapActions({}),
		fetchCurrent() {
			this.isFetching = true;
			const params = this.params;
			const callback = (response) => {
				const settings = response.data;
				this.setCurrentSetting(settings);
				this.isFetching = false;
			};
			const errorCallback = (e) => {
				const msg = getAxiosErrorMessage(e);
				// eslint-disable-next-line
				console.log(msg);
			};
			settingApi.getCurrent(params, callback, errorCallback);
		},
		setCurrentSetting(settings) {
			this.productApprovalTime = settings?.data?.product_approval_time ?? '';
			this.currentApprovalTime = settings?.data?.product_approval_time ?? '';
			this.followUpTextUser = settings?.data?.follow_up_text?.user ?? defaultFollowUpMessage;
			this.followUpTextSupplier = settings?.data?.follow_up_text?.supplier ?? defaultFollowUpMessage;
			this.welcomingMessages = settings?.data?.welcoming_message ?? duplicateVar(defaultWelcomingMessage);
			this.whatsapp = settings?.data?.whatsapp ?? defaultWhatsappAPI;
			this.googleAnalyticsKey = settings?.data?.google_analytics ?? '';
			this.notifReceiver = settings?.data?.notif_receiver ?? [];
			this.productSourcingFee = settings?.data?.product_sourcing_fee ?? { enabled: false };
			this.metaPixels = settings?.data?.meta_pixels ?? [this.metaPixelRegister];
			this.bestSellerViews = settings?.data?.best_seller_view ?? [];

			if (!this.whatsapp?.devices) {
				this.whatsapp.devices = defaultWhatsappAPI.devices;
			}
		},
		openModalGoogleAnalytics() {
			this.googleAnalyticsKeyForm = duplicateVar(this.googleAnalyticsKey);
			this.isShowModalGoogleAnalytics = true;
		},
		openModalMetaPixel(pixelItem) {
			this.selectedMetaPixel = duplicateVar(pixelItem);
			this.selectedPixelIds = this.selectedMetaPixel?.ids ?? [];
			this.selectedPixelEvents = this.selectedMetaPixel?.events ?? [];
			this.isShowModalMetaPixel = true;
		},
		openModalWatzap() {
			this.whatsappForm = duplicateVar(this.whatsapp);
			this.isShowModalWatZap = true;
		},
		saveGoogleAnalytics() {
			const body = {
				key: 'google_analytics',
				value: this.googleAnalyticsKeyForm,
			};
			this.isSaveChange = true;
			const callback = (response) => {
				const message = response.message;
				this.isSaveChange = false;
				this.isShowModalGoogleAnalytics = false;
				this.googleAnalyticsKey = duplicateVar(this.googleAnalyticsKeyForm);

				this.$notify({
					group: 'settings',
					title: 'Setting',
					text: message,
					type: 'success',
				});
			};
			const errorCallback = (e) => {
				const msg = getAxiosErrorMessage(e);
				// eslint-disable-next-line
				this.$notify({
					group: 'settings',
					title: 'Setting',
					text: msg,
					type: 'error',
				});
				console.log(msg);
			};
			settingApi.changeValue(body, callback, errorCallback);
		},
		saveMetaPixel(type = 'form') {
			this.selectedMetaPixel.ids = this.selectedPixelIds;
			this.selectedMetaPixel.events = this.selectedPixelEvents;

			const metaPixels = duplicateVar(this.metaPixels);
			if (type === 'form') {
				const currentIndex = metaPixels.findIndex(item => item.type === this.selectedMetaPixel.type);
				if (currentIndex !== -1) {
					console.log('this.selectedMetaPixel');
					console.log(this.selectedMetaPixel);
					metaPixels[currentIndex] = this.selectedMetaPixel;
				}
			}

			const body = {
				key: 'meta_pixels',
				value: JSON.stringify(metaPixels),
			};

			this.isSaveChange = true;

			const callback = (response) => {
				const message = response.message;
				this.isSaveChange = false;
				this.isShowModalMetaPixel = false;
				this.metaPixels = duplicateVar(metaPixels);

				this.$notify({
					group: 'settings',
					title: 'Setting',
					text: message,
					type: 'success',
				});
			};

			const errorCallback = (e) => {
				const msg = getAxiosErrorMessage(e);
				// eslint-disable-next-line
				this.$notify({
					group: 'settings',
					title: 'Setting',
					text: msg,
					type: 'error',
				});
				console.log(msg);
			};

			settingApi.changeValue(body, callback, errorCallback);
		},
		saveWatzap() {
			const body = {
				key: 'whatsapp',
				value: JSON.stringify(this.whatsappForm),
			};
			this.isSaveChange = true;
			const callback = (response) => {
				const message = response.message;
				this.isSaveChange = false;
				this.isShowModalWatZap = false;
				this.whatsapp = duplicateVar(this.whatsappForm);

				this.$notify({
					group: 'settings',
					title: 'Setting',
					text: message,
					type: 'success',
				});
			};
			const errorCallback = (e) => {
				const msg = getAxiosErrorMessage(e);
				// eslint-disable-next-line
				this.$notify({
					group: 'settings',
					title: 'Setting',
					text: msg,
					type: 'error',
				});
				console.log(msg);
			};
			settingApi.changeValue(body, callback, errorCallback);
		},
		saveProductApprovalTime() {
			const body = {
				key: 'product_approval_time',
				value: this.productApprovalTime,
			};
			this.isSaveChange = true;
			const callback = (response) => {
				const message = response.message;
				this.isSaveChange = false;
				this.isShowModalProductApprovalTime = false;

				this.$notify({
					group: 'settings',
					title: 'Setting',
					text: message,
					type: 'success',
				});
			};
			const errorCallback = (e) => {
				const msg = getAxiosErrorMessage(e);
				// eslint-disable-next-line
				this.$notify({
					group: 'settings',
					title: 'Setting',
					text: msg,
					type: 'error',
				});
				console.log(msg);
			};
			settingApi.changeValue(body, callback, errorCallback);
		},
		setFollowUpText() {
			const followUpParam = {
				user: this.followUpTextUser,
				supplier: this.followUpTextSupplier,
			};
			const body = {
				key: 'follow_up_text',
				value: JSON.stringify(followUpParam),
			};
			this.isSaveChange = true;
			const callback = (response) => {
				const message = response.message;
				this.isSaveChange = false;

				this.$notify({
					group: 'settings',
					title: 'Setting',
					text: message,
					type: 'success',
				});
			};
			const errorCallback = (e) => {
				const msg = getAxiosErrorMessage(e);
				// eslint-disable-next-line
				this.$notify({
					group: 'settings',
					title: 'Setting',
					text: msg,
					type: 'error',
				});
				console.log(msg);
			};
			settingApi.changeValue(body, callback, errorCallback);
		},
		setWelcomingMessage() {
			const welcomingMessageParam = this.welcomingMessages;
			const body = {
				key: 'welcoming_message',
				value: JSON.stringify(welcomingMessageParam),
			};
			this.isSaveChange = true;
			const callback = (response) => {
				const message = response.message;
				this.isSaveChange = false;

				this.$notify({
					group: 'settings',
					title: 'Setting',
					text: message,
					type: 'success',
				});
			};
			const errorCallback = (e) => {
				const msg = getAxiosErrorMessage(e);
				// eslint-disable-next-line
				this.$notify({
					group: 'settings',
					title: 'Setting',
					text: msg,
					type: 'error',
				});
				console.log(msg);
			};
			settingApi.changeValue(body, callback, errorCallback);
		},
		addPixelId(value) {
			value = value.trim();
			this.selectedPixelIds.push(value);

			// Update Pixel ID
			const pixelIds = duplicateVar(this.pixelIds);
			if (pixelIds.indexOf(value) === -1) {
				pixelIds.push(value);
				usersApi.udpatePixelIds(pixelIds);
			}
		},
		removePixelId(index) {
			this.selectedPixelIds.splice(index, 1);
		},
		addPixelEvent(value) {
			value = value.trim();
			this.selectedPixelEvents.push(value);
		},
		removePixelEvent(index) {
			this.selectedPixelEvents.splice(index, 1);
		},
		setSelectedCategory(type, category, index) {
			if (type === 'user') {
				this.selectedCategoryUser = {
					...category,
					index,
				};
			}
			if (type === 'supplier') {
				this.selectedCategorySupplier = {
					...category,
					index,
				};
			}
		},
		setSelectedWelcomingMessageCategory(category) {
			this.selectedWelcomingMessageCategory = {
				...category,
			};
		},
		resetNotifReceiverItem() {
			this.notifReceiverItem = {
				label: '',
				phone_number: '',
				capabilities: [],
			};
		},
		toggleNotifReceiverModal(state = true, type = 'edit', item = null) {
			this.isShowModalNotifReceiver = state;
			this.notifReceiverState = type;

			if (item) {
				this.notifReceiverItem = item;
			} else {
				this.resetNotifReceiverItem();
			}

			this.notifReceiverError = {
				label: '',
				phone_number: '',
			};
		},
		validateNotifReceiver() {
			if (this.notifReceiverItem.label === '') {
				this.notifReceiverError.label = 'Wajib Diisi';
			} else {
				this.notifReceiverError.label = '';
			}

			if (this.notifReceiverItem.phone_number === '') {
				this.notifReceiverError.phone_number = 'Wajib Diisi';
			} else {
				this.notifReceiverError.phone_number = '';
			}

			if (this.notifReceiverError.label === '' && this.notifReceiverError.phone_number === '') {
				this.saveNotifReceiver();
			}
		},
		saveNotifReceiver() {
			const tempNotifReceiver = duplicateVar(this.notifReceiver);
			if (this.notifReceiverState === 'create') {
				this.notifReceiver.push(this.notifReceiverItem);
			}

			const body = {
				key: 'notif_receiver',
				value: JSON.stringify(this.notifReceiver),
			};

			this.isSaveChange = true;

			const callback = (response) => {
				const message = response.message;
				this.isSaveChange = false;
				this.toggleNotifReceiverModal(false);
				this.resetNotifReceiverItem();

				this.$notify({
					group: 'settings',
					title: 'Setting',
					text: message,
					type: 'success',
				});
			};

			const errorCallback = (e) => {
				const msg = getAxiosErrorMessage(e);
				// eslint-disable-next-line
				this.$notify({
					group: 'settings',
					title: 'Setting',
					text: msg,
					type: 'error',
				});
				console.log(msg);

				this.isSaveChange = false;

				// Reset Value
				this.notifReceiver = duplicateVar(tempNotifReceiver);
			};

			settingApi.changeValue(body, callback, errorCallback);
		},
		formatPixelIds(pixelItem) {
			return pixelItem?.ids?.join(', ') ?? '';
		},
		formatTrackingEvents(pixelItem) {
			return pixelItem?.events?.join(', ') ?? '';
		},
		removeReceiver(index) {
			this.notifReceiver.splice(index, 1);
			this.isOnDeleteNotifReceiver = true;
		},
		inputPhone() {
			let phone = this.notifReceiverItem.phone_number;
			phone = phone.replace(/[^\d]/g, '');

			this.notifReceiverItem.phone_number = phone;
		},
		onChangeProductSourcingFee() {
			this.isShowModalConfirmProductSoucingFee = true;
		},
		onChangeEnabledPixelItem() {
			this.saveMetaPixel('toggle');
		},
		onCancelProductSourcingFee() {
			this.isShowModalConfirmProductSoucingFee = false;
			this.productSourcingFee.enabled = !this.productSourcingFee.enabled;
		},
		saveProductSourcingFee() {
			const body = {
				key: 'product_sourcing_fee',
				value: JSON.stringify(this.productSourcingFee),
			};
			this.isSaveChange = true;
			const callback = (response) => {
				const message = response.message;
				this.isSaveChange = false;
				this.isShowModalConfirmProductSoucingFee = false;

				this.$notify({
					group: 'settings',
					title: 'Setting',
					text: message,
					type: 'success',
				});
			};
			const errorCallback = (e) => {
				const msg = getAxiosErrorMessage(e);
				// eslint-disable-next-line
				this.$notify({
					group: 'settings',
					title: 'Setting',
					text: msg,
					type: 'error',
				});
				console.log(msg);
			};
			settingApi.changeValue(body, callback, errorCallback);
		},
		validateBestSellerViewForm() {
			if (this.bestSellerViewItem.seller_id === null) {
				this.bestSellerViewError.seller_id = 'Wajib Diisi';
			} else {
				this.bestSellerViewError.seller_id = '';
			}
			// check if seller id already added
			const indexSeller = this.bestSellerViews.findIndex(currItem => currItem.seller_id === this.bestSellerViewItem.seller_id);
			const isSellerExist = indexSeller !== -1;
			if (isSellerExist && this.bestSellerViewState !== 'edit') {
				this.$notify({
					group: 'settings',
					title: 'Best Seller View',
					text: 'Selected Seller is Already Added, Please Select Other Seller!',
					type: 'error',
				});
				return;
			}
			if (this.bestSellerViewError.seller_id === '') {
				this.bestSellerViewItem.updated_at = dayjs().format('DD-MM-YYYY HH:mm');
				this.saveBestSellerView();
			}
		},
		resetBestSellerViewItem() {
			this.bestSellerViewSelectedSeller = null;
			this.bestSellerViewItem = {
				seller_id: null,
				seller_name: null,
				seller_email: null,
				updated_at: null,
			};
		},
		toggleBestSellerViewModal(state = true, type = 'edit', item = null) {
			this.isShowModalBestSellerView = state;
			this.bestSellerViewState = type;
			if (item) {
				this.bestSellerViewItem = item;
				this.bestSellerViewSelectedSeller = {
					_id: item?.seller_id,
					name: item?.seller_name,
					emailOwner: item?.seller_email ?? '',
				};
			} else {
				this.resetBestSellerViewItem();
			}
			this.bestSellerViewError = {
				seller_id: '',
				seller_name: '',
			};
		},
		sellerOptionLabel({ name, emailOwner }) {
			const label = `${name} - ${emailOwner}`;
			return label;
		},
		fetchDataSeller(query) {
			this.isFetchingSellers = true;
			const params = {
				limit: 100,
				keyword: query,
				role: 'owner',
				owner_type: 'dropshipper',
			};
			const callback = (response) => {
				let sellers = response.data;
				if (sellers.length > 0) {
					sellers = sellers.map((data) => {
						const newObj = {
							_id: data?._id?.$oid ?? data?._id,
							name: data?.name ?? '',
							emailOwner: data?.email ?? '',
						};
						return newObj;
					});
				}
				this.sellerOptions = sellers;
				this.isFetchingSellers = false;
			};
			const errorCallback = () => {
				this.isFetchingSellers = false;
			};
			usersApi.getUsersMinimal(params, callback, errorCallback);
		},
		searchSeller(query) {
			if (query !== '') {
				this.ooDelay(() => {
					this.fetchDataSeller(query, 'recent');
				}, 1000);
			}
		},
		onBestSellerViewSellerSelected(seller) {
			this.bestSellerViewItem.seller_id = seller?._id;
			this.bestSellerViewItem.seller_name = seller?.name;
			this.bestSellerViewItem.seller_email = seller?.emailOwner;
		},
		removeBestSellerView(index) {
			this.bestSellerViews.splice(index, 1);
			this.isOnDeleteBestSellerView = true;
		},
		saveBestSellerView() {
			const tempBestSellerViews = duplicateVar(this.bestSellerViews);
			if (this.bestSellerViewState === 'create') {
				this.bestSellerViews.push(this.bestSellerViewItem);
			}
			const body = {
				key: 'best_seller_view',
				value: JSON.stringify(this.bestSellerViews),
			};
			this.isSaveChange = true;
			const callback = (response) => {
				const message = response.message;
				this.isSaveChange = false;
				this.toggleBestSellerViewModal(false);
				this.resetBestSellerViewItem();
				this.$notify({
					group: 'settings',
					title: 'Setting',
					text: message,
					type: 'success',
				});
			};
			const errorCallback = (e) => {
				const msg = getAxiosErrorMessage(e);
				this.$notify({
					group: 'settings',
					title: 'Setting',
					text: msg,
					type: 'error',
				});
				this.isSaveChange = false;
				// Reset Value
				this.bestSellerViews = duplicateVar(tempBestSellerViews);
			};
			settingApi.changeValue(body, callback, errorCallback);
		},
	},
	computed: {
		...mapGetters({
			isUserCan: 'isUserCan',
			pixelIds: 'pixelIds',
		}),
		isDisableWatZapForm() {
			return this.whatsappForm.base_url === ''
				|| this.whatsappForm.api_key === ''
				|| this.whatsappForm.number_key === '';
		},
		unselectedPixelIds() {
			return this.pixelIds.filter(id => this.selectedPixelIds.indexOf(id) === -1);
		},
		unselectedPixelEvents() {
			return this.pixelEvents.filter(id => this.selectedPixelEvents.indexOf(id) === -1);
		},
		allowedMetaPixels() {
			return this.metaPixels.filter(pixelItem => metaPixelItems.includes(pixelItem?.type));
		},
	},
	created() {
		this.fetchCurrent();
	},
};
</script>
<style lang="scss">
@import '../assets/scss/modules/_variables.scss';

.fu-editor {
	margin-bottom: 0;
	border-top: 0;

	&.box {
		border: 1px solid $color__border;
		border-top: 0;
		box-shadow: none !important;
	}
}

.fu-editor__textarea {
	border-radius: 0px !important;
}
</style>

<style scoped>
.icon-whatsapp {
	font-size: 24px;
}

.phone {
	font-weight: 500;
}

.label {
	font-weight: 100;
	font-size: 14px;
}

table thead th {
	border-bottom: 1px solid #dddddd;
	border-top: 0;
}

.loading-wrapper-pixel {
	padding-top: 2em;
	padding-bottom: 3em;
	min-height: 63px;
}
</style>
